import script from "./detalle_oferta.vue?vue&type=script&setup=true&lang=js"
export * from "./detalle_oferta.vue?vue&type=script&setup=true&lang=js"

import "./detalle_oferta.vue?vue&type=style&index=0&id=88cd03e4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88cd03e4"]])

export default __exports__